import { cn } from '@/lib/utils'
import { type TourDescriptionProps, tourDescriptionVariants } from './tour-variants'

export function TourDescription({ children, size, className }: TourDescriptionProps) {
  return <p className={cn(tourDescriptionVariants({ size }), className)}>{children}</p>
}
